import React from 'react';
import InvestorBlock from '../Investor/InvestorBlock';
import ContentList from '../Investor/ContentList';
import WinCard from '../../components/WinCard';

interface IProps {
  title: string;
  anchor: string;
  winData: Array<{ [key: string]: string }>;
  winDetailText: string;
}

function WinCardList(props: IProps) {
  const { title, anchor, winData, winDetailText } = props;

  return (
    <>
      <InvestorBlock title={title} anchor={anchor}>
        <ContentList>
          {winData?.map((item) => {
            return (
              <WinCard
                key={item.cardName}
                cardName={item.cardName}
                cardDec={item.cardDec}
                cardLink={item.cardLink}
                winDetailText={winDetailText}
              />
            );
          })}
        </ContentList>
      </InvestorBlock>
    </>
  );
}

WinCardList.displayName = 'WinCardList';
export default WinCardList;
